/* unplugin-vue-components disabled */import script from "./TEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./TEditor.vue?vue&type=script&setup=true&lang=ts"

import "./TEditor.vue?vue&type=style&index=0&id=6b99cc88&lang=less"

const __exports__ = script;

export default __exports__